exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Activities-module__wrapper___EbjbC{display:grid;gap:32px;grid-template-columns:repeat(auto-fill,minmax(378px,1fr));padding:64px 0}@media screen and (max-width:525px){.Activities-module__wrapper___EbjbC{grid-template-columns:1fr}}", ""]);

// exports
exports.locals = {
	"wrapper": "Activities-module__wrapper___EbjbC"
};